import React from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { TestimonialsHero } from './components/TestimonialsHero';
import { PainPoints } from './components/PainPoints';
import { Positioning } from './components/Positioning';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { EliteUpgrade } from './components/EliteUpgrade';
import { Comparison } from './components/Comparison';
import { TestimonialsExtended } from './components/TestimonialsExtended';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FooterCTA } from './components/FooterCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { useMetaPixel } from './components/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="min-h-screen bg-white font-sans selection:bg-blue-200 selection:text-blue-900" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProof data-id="element-2" />
      <TestimonialsHero data-id="element-3" />
      <PainPoints data-id="element-4" />
      <Positioning data-id="element-5" />
      <Volumes data-id="element-6" />
      <Bonuses data-id="element-7" />
      <Pricing data-id="element-8" />
      <EliteUpgrade data-id="element-9" />
      <Comparison data-id="element-10" />
      <TestimonialsExtended data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FAQ data-id="element-13" />
      <FooterCTA data-id="element-14" />

      <PurchasePopup data-id="element-15" />
    </div>;
}